import { filesize } from 'filesize';

import { NUMBER_FORMAT } from 'services/number';

export function getEffectiveUtilizationLimit(
  planLimit?: number | null,
  userLimit?: number | null
) {
  const hasPlanLimit = Number.isFinite(planLimit);
  const hasUserLimit = Number.isFinite(userLimit);

  if (hasUserLimit) {
    return Number(userLimit);
  }

  if (hasPlanLimit) {
    return Number(planLimit);
  }

  return null;
}

export function getLowerUtilizationLimit(
  firstLimit?: number | null,
  secondLimit?: number | null
) {
  const hasFirstLimit = Number.isFinite(firstLimit);
  const hasSecondLimit = Number.isFinite(secondLimit);

  if (hasFirstLimit && hasSecondLimit) {
    return Math.min(Number(firstLimit), Number(secondLimit));
  }

  if (hasFirstLimit) {
    return Number(firstLimit);
  }

  if (hasSecondLimit) {
    return Number(secondLimit);
  }

  return null;
}

/** Formats a bare usage/limit amount without a unit suffix. */
export function formatUtilizationValue(
  value: number,
  unit?: 'filesize' | string
) {
  if (unit === 'filesize') {
    return filesize(value, { base: 2 });
  }

  return NUMBER_FORMAT.format(value);
}

export function formatUtilizationLimit(
  limit: number | null | undefined,
  unit?: 'filesize' | string,
  fallbackUnit?: string
) {
  if (!Number.isFinite(limit)) {
    return 'Unlimited';
  }

  if (unit === 'filesize') {
    return filesize(Number(limit), { base: 2 });
  }

  const displayUnit = fallbackUnit ?? unit;
  const displayLimit = NUMBER_FORMAT.format(Number(limit));

  return displayUnit ? `${displayLimit} ${displayUnit}` : displayLimit;
}
